'use client'

import * as React from 'react'

import AlbumContainer from '@/components/AlbumContainer'
import AlbumsOverview from '@/components/AlbumsOverview'
import type { AlbumPayload } from '@/constant/types'
import useInView from '@/lib/hooks/useInView'

type AlbumPageProps = {
  album: AlbumPayload
  otherAlbums?: AlbumPayload[]
}

export default function AlbumPage({ album, otherAlbums }: AlbumPageProps) {
  const { title, _id, date, header, subheader, photos, copy } = album

  const [testRef, isAlbumVisible] = useInView({
    threshold: 0,
  })

  const AlbumsNav = (
    <>
      {otherAlbums && (
        <AlbumsOverview
          excludeAlbumId={_id}
          albums={otherAlbums}
          enableHover={!isAlbumVisible}
        />
      )}
    </>
  )

  return (
    <AlbumContainer
      photos={photos}
      title={title}
      header={header}
      date={date}
      subheader={subheader}
      copy={copy}
      visibilityTester={testRef}
      AlbumsNav={AlbumsNav}
      albumNavClassName='full--bleed-padding'
    />
  )
}
